module.exports = __webpack_public_path__ + "static/img/bg_login_big.fb8da2af.png";